import React from 'react';

import Login from 'features/auth/components/Login';
import { useTranslation } from 'hooks/useTranslation';
import { Title } from 'shared';

export const LoginPage = () => {
  const { t } = useTranslation('auth');

  return (
    <>
      <Title title={t('logIn')} />
      <Login />
    </>
  );
};
